import { Dispatch } from 'react';
import {
    BrandingActionTypes,
    GenerateBrandingErrorAction,
    GENERATE_BRANDING_ERROR,
    GetBrandingAction,
    GET_BRANDING,
} from '../types';
import { Branding } from '../../../../models/Branding';
import { fetchBranding } from '../../../../services/BrandingAPI';

export function getBranding(): (dispatch: Dispatch<BrandingActionTypes>) => void {
    return async (dispatch: Dispatch<BrandingActionTypes>) => {
        try {
            const branding = await fetchBranding();
            dispatch(receiveBranding(branding));
        } catch (error) {
            dispatch(receiveBrandingWithError(error));
        }
    };
}

const receiveBranding = (branding: InstanceType<typeof Branding>): GetBrandingAction => {
    return {
        type: GET_BRANDING,
        payload: branding,
    };
};

const receiveBrandingWithError = (error: Error): GenerateBrandingErrorAction => {
    return {
        type: GENERATE_BRANDING_ERROR,
        error,
    };
};
